import React, { useEffect, useState } from 'react';
const LoadedAssetsUI = (props: LoadedAssetsUIConfig) => {
	return (
		<div>
			<div style={{
				backgroundColor: 'rgba(0,0,0, 0.85)'
			}}>
				<p style={{
					color: 'green',
					margin: 0,
					fontSize: '12pt'
				}}>
					{'Available Memory: ' + props.memory + ' bytes'}
				</p>
				{props.assets.map((element: string, index: number) => {
					return (
						<p style={{
							color: 'green',
							margin: 0,
							fontSize: '12pt'
						}}>{element}</p>
					);
				})}
			</div>
		</div>
	);

};

export interface LoadedAssetsUIConfig {
	assets: string[];
	memory: string;
}

export default LoadedAssetsUI;